import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { BaseStationService } from '../base-stations-listing.service';
import { BaseStationTable } from '../base-stations-listing-page.types';

@Injectable()
export class BaseStationListingDataSourceService implements ListingDataSource<BaseStationTable> {
  private readonly baseStationService = inject(BaseStationService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<BaseStationTable> {
    return this.baseStationService.getTableData(tableState);
  }
}
